import { __extends, __awaiter, __generator, __decorate, __metadata } from 'tslib';
import { getFeatureEnabled, formatCurrency, interpolate, FeatureEnabledV2, MagicConfigMixin, BalanceMixin } from '@gig/magic-common';
import { Prop, Component, Mixins } from 'vue-property-decorator';
import { Currency } from '@gig/magic-sdk/dist/adapter/users/signup';
import { US_DOLLARS_BALANCE_UPDATED, BALANCE_UPDATED, LOCKED_AMOUNT_UPDATED, IS_REDEEM_FLOW_UPDATED, BALANCE_QUERY, BALANCE_FIAT_CURRENCY_QUERY, Feature } from '@gig/magic-messages';
import { magic } from '@gig/magic-sdk';
import { calculateRedeemableSweepFiat, isSweepcoinsAndFiatRatioEnabled, getSweepRatio, formatBalanceWithDigits, formatBalance } from '../../utils/helpers.js';

var SweepstakesTooltip = /** @class */ (function (_super) {
    __extends(SweepstakesTooltip, _super);
    function SweepstakesTooltip() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.abbreviateSweepcoins = true;
        _this.isDiamondCoinsEnabled = false;
        _this.diamondsAmount = null;
        _this.hasUSD = false;
        _this.isSweepcoinsAndFiatRatioEnabled = false;
        _this.redeemableSweepFiat = null;
        _this.Currency = Currency;
        _this.lockedAmount = 0;
        _this.lockedUSD = null;
        _this.numericRatio = 0;
        _this.hasCancelRedeemFailed = false;
        _this.hasRedeemFlowStarted = false;
        return _this;
    }
    SweepstakesTooltip.prototype.created = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b, _c, _d;
            var _this = this;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        this.refreshBalance();
                        _a = this;
                        return [4 /*yield*/, getSweepRatio()];
                    case 1:
                        _a.numericRatio = _e.sent();
                        _b = this;
                        return [4 /*yield*/, getFeatureEnabled('sweepstakes-diamond-coins')];
                    case 2:
                        _b.isDiamondCoinsEnabled = _e.sent();
                        _c = this;
                        return [4 /*yield*/, isSweepcoinsAndFiatRatioEnabled()];
                    case 3:
                        _c.isSweepcoinsAndFiatRatioEnabled =
                            _e.sent();
                        this.getDiamondAmount();
                        _d = this;
                        return [4 /*yield*/, calculateRedeemableSweepFiat(this.sweepBalance.withdrawable, this.isSweepcoinsAndFiatRatioEnabled)];
                    case 4:
                        _d.redeemableSweepFiat = _e.sent();
                        this.usDollarsBalanceSubscription = window.eventBus.subscribe(US_DOLLARS_BALANCE_UPDATED, function (event) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                this.hasUSD = event.payload;
                                return [2 /*return*/];
                            });
                        }); }, { replay: true });
                        window.eventBus.subscribe(BALANCE_UPDATED, function (event) {
                            _this.refreshBalance();
                        });
                        this.cancelRedeemFailSubscription = window.eventBus.subscribe(LOCKED_AMOUNT_UPDATED, function (event) { return __awaiter(_this, void 0, void 0, function () {
                            var _a;
                            return __generator(this, function (_b) {
                                this.hasCancelRedeemFailed = (_a = event === null || event === void 0 ? void 0 : event.payload) !== null && _a !== void 0 ? _a : false;
                                return [2 /*return*/];
                            });
                        }); }, { replay: true });
                        this.hasRedeemFlowStartedSubscription =
                            window.eventBus.subscribe(IS_REDEEM_FLOW_UPDATED, function (event) { return __awaiter(_this, void 0, void 0, function () {
                                var _a;
                                return __generator(this, function (_b) {
                                    this.hasRedeemFlowStarted = (_a = event === null || event === void 0 ? void 0 : event.payload) !== null && _a !== void 0 ? _a : false;
                                    return [2 /*return*/];
                                });
                            }); }, { replay: true });
                        return [2 /*return*/];
                }
            });
        });
    };
    SweepstakesTooltip.prototype.refreshBalance = function () {
        return __awaiter(this, void 0, void 0, function () {
            var balance;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Promise.all([this.queryBalance()])];
                    case 1:
                        balance = (_a.sent())[0];
                        this.lockedUSD = balance;
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(SweepstakesTooltip.prototype, "formattedSweepBalance", {
        get: function () {
            var _a, _b;
            var amount = ((_b = (_a = this.lockedUSD) === null || _a === void 0 ? void 0 : _a.balance) !== null && _b !== void 0 ? _b : 0) * this.numericRatio;
            return formatBalanceWithDigits(amount, this.abbreviateSweepcoins);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SweepstakesTooltip.prototype, "formattedUSDBalance", {
        get: function () {
            var _a, _b;
            var amount = (_b = (_a = this.lockedUSD) === null || _a === void 0 ? void 0 : _a.balance) !== null && _b !== void 0 ? _b : 0;
            var formatted = formatBalance(amount, this.abbreviateSweepcoins);
            var currencySymbol = formatCurrency(0, this.currencyCode)
                .replace(/[\d.,\s]/g, '')
                .trim();
            return "(" + currencySymbol + formatted + ")";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SweepstakesTooltip.prototype, "sweepBalanceWithdrawable", {
        get: function () {
            var _a, _b;
            return formatBalanceWithDigits((_b = (_a = this.sweepBalance) === null || _a === void 0 ? void 0 : _a.withdrawable) !== null && _b !== void 0 ? _b : 0, this.abbreviateSweepcoins);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SweepstakesTooltip.prototype, "sweepBalanceFormatted", {
        get: function () {
            if (this.gameRunning && this.activeCurrency === Currency.SWP) {
                return this.$t('sweepstakes.balance.playing');
            }
            var formatted = formatBalanceWithDigits(this.sweepBalance.balance, this.abbreviateSweepcoins);
            return interpolate(this.$t('sweepstakes.sweepcoins-long'), {
                amount: formatted,
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SweepstakesTooltip.prototype, "goldBalanceFormatted", {
        get: function () {
            if (this.gameRunning && this.activeCurrency === Currency.GLD) {
                return this.$t('sweepstakes.balance.playing');
            }
            var formatted = formatBalance(this.goldBalance.balance, this.abbreviateSweepcoins);
            return interpolate(this.$t('sweepstakes.goldcoins-long'), {
                amount: formatted,
            });
        },
        enumerable: false,
        configurable: true
    });
    SweepstakesTooltip.prototype.getDiamondAmount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var rewards, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.isDiamondCoinsEnabled) {
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, magic.invokeCached(60, magic.methods.rewards, 'getUserRewards')()];
                    case 2:
                        rewards = (_a.sent()).rewards;
                        this.diamondsAmount = (rewards === null || rewards === void 0 ? void 0 : rewards.echoes) || 0;
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        console.error('Failed to fetch diamond amount:', error_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(SweepstakesTooltip.prototype, "showLockedAmountSection", {
        get: function () {
            var _a, _b;
            var lockedBalance = (_b = (_a = this.lockedUSD) === null || _a === void 0 ? void 0 : _a.balance) !== null && _b !== void 0 ? _b : 0;
            var hasLockedBalance = lockedBalance > 0;
            var redeemNotStarted = !this.hasRedeemFlowStarted;
            var isSWPCurrencyAndHasCancelRedeemFailed = this.activeCurrency === Currency.SWP && this.hasCancelRedeemFailed;
            return (redeemNotStarted &&
                hasLockedBalance &&
                (isSWPCurrencyAndHasCancelRedeemFailed || this.hasUSD));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SweepstakesTooltip.prototype, "sweepBalanceDisplayData", {
        get: function () {
            var isSweepCoinSelected = this.activeCurrency === Currency.SWP;
            return {
                isPlaying: isSweepCoinSelected && this.gameRunning,
                sweepBalance: this.sweepBalanceLocked,
                withdrawable: this.sweepBalanceWithdrawable,
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SweepstakesTooltip.prototype, "sweepBalanceLocked", {
        get: function () {
            var _a, _b;
            return formatBalanceWithDigits((_b = (_a = this.sweepBalance) === null || _a === void 0 ? void 0 : _a.locked) !== null && _b !== void 0 ? _b : 0, this.abbreviateSweepcoins);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SweepstakesTooltip.prototype, "diamondBalanceLong", {
        get: function () {
            return interpolate(this.$t('sweepstakes.diamondcoins-long'), {
                amount: this.diamondsAmount,
            });
        },
        enumerable: false,
        configurable: true
    });
    SweepstakesTooltip.prototype.queryBalance = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, window.queryBus.query(BALANCE_FIAT_CURRENCY_QUERY)];
                    case 1:
                        _a.currencyCode = _b.sent();
                        return [2 /*return*/, window.queryBus.query(BALANCE_QUERY, this.currencyCode)];
                }
            });
        });
    };
    SweepstakesTooltip.prototype.destroyed = function () {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_d) {
                (_a = this.usDollarsBalanceSubscription) === null || _a === void 0 ? void 0 : _a.unsubscribe();
                (_b = this.cancelRedeemFailSubscription) === null || _b === void 0 ? void 0 : _b.unsubscribe();
                (_c = this.hasRedeemFlowStartedSubscription) === null || _c === void 0 ? void 0 : _c.unsubscribe();
                return [2 /*return*/];
            });
        });
    };
    __decorate([
        Prop(Object),
        __metadata("design:type", Object)
    ], SweepstakesTooltip.prototype, "goldBalance", void 0);
    __decorate([
        Prop(Object),
        __metadata("design:type", Object)
    ], SweepstakesTooltip.prototype, "sweepBalance", void 0);
    __decorate([
        Prop(Object),
        __metadata("design:type", Object)
    ], SweepstakesTooltip.prototype, "gameRunning", void 0);
    __decorate([
        Prop(String),
        __metadata("design:type", String)
    ], SweepstakesTooltip.prototype, "activeCurrency", void 0);
    __decorate([
        FeatureEnabledV2({
            slug: Feature.ABBREVIATE_SWEEPCOINS,
        }),
        __metadata("design:type", Object)
    ], SweepstakesTooltip.prototype, "abbreviateSweepcoins", void 0);
    SweepstakesTooltip = __decorate([
        Component({
            name: 'sweepstakes-tooltip',
        })
    ], SweepstakesTooltip);
    return SweepstakesTooltip;
}(Mixins(MagicConfigMixin, BalanceMixin)));

export default SweepstakesTooltip;
